import { createI18n } from 'vue-i18n';
import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';
import { detectDefaultLocale, type AppLocale } from './detect-locale';

export const i18n = createI18n({
  legacy: false,
  locale: detectDefaultLocale(),
  fallbackLocale: 'en' as AppLocale,
  // fr/es/it are machine-translated, pending native review (see each file's _meta).
  messages: { de, en, fr, es, it },
});

export function setAppLocale(locale: AppLocale) {
  i18n.global.locale.value = locale;
}
